"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const agent_1 = require("@dfinity/agent");
const jelly_hub_did_1 = require("./declarations/jelly-hub-did");
const canisters_1 = require("./config/canisters");
const jelly_hub_1 = __importDefault(require("./integrations/jelly-hub"));
const jelly_collection_1 = __importDefault(require("./jelly-collection"));
const marketplace_1 = __importDefault(require("./integrations/marketplace"));
const wicp_1 = __importDefault(require("./integrations/wicp"));
const collection_1 = __importDefault(require("./integrations/collection"));
const AnonAgent = new agent_1.HttpAgent({ host: 'https://mainnet.dfinity.network' });
class JellyUtils {
    constructor(agent = AnonAgent) {
        // Only for development
        this.initRootKey = () => __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === 'production') {
                return null;
            }
            return this.agent.fetchRootKey().catch((err) => {
                console.error(err);
                console.error('Unable to fetch root key. Check to ensure that your local replica is running');
                throw err;
            });
        });
        this.getCollections = () => __awaiter(this, void 0, void 0, function* () {
            return this.hubService.getCollections();
        });
        this.getJellyCollection = (collection) => {
            const marketplaceService = new marketplace_1.default(this.agent, collection);
            const wicpService = new wicp_1.default(this.agent, collection);
            const collectionService = new collection_1.default(this.agent, collection);
            return new jelly_collection_1.default(collection, marketplaceService, wicpService, collectionService, this.hubService);
        };
        this.agent = agent;
        this.actor = agent_1.Actor.createActor(jelly_hub_did_1.idlFactory, {
            canisterId: (0, canisters_1.getJellyHubCanisterId)(),
            agent
        });
        this.hubService = new jelly_hub_1.default(this.agent);
    }
}
exports.default = JellyUtils;
